module.exports = __webpack_public_path__ + "img/14.e9ff9960.jpg";